import { Box, Container } from '@mui/material'
import { useEffect, useState } from 'react'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import ListOperations from './ListOperations'
import UpdateListe from './UpdateListe'
import CreateMessage from 'containers/MyInbox/CreateMessage'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export const MesListe = ({
  CreateListeModal,
  updateTodo = false,
  createListe,
  setListeTaskId,
  setListeTaskName,
}) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [mOpen, setMOpen] = useState(false)
  const [updateListeForm, setUpdateListeForm] = useState(false)
  const [operations, setOperations] = useState({})
  const [selectedOperation, setSelectedOpertation] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  useEffect(() => {
    fetchOperations()
  }, [createListe])

  const fetchOperations = async (pagination = '') => {
    let url = `${urls.listeOperations}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
    }
  }
  const handelUpdte = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      let row = operations.results.filter((v) => v.id === selectedRows[0])
      setSelectedOpertation(row[0])
      setUpdateListeForm(true)
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('mesToDo.selectOperationAlert'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkListeOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        updateTodo()
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      {updateListeForm && (
        <UpdateListe
          setUpdateListe={setUpdateListeForm}
          updateTodo={fetchOperations}
          row={selectedOperation}
        />
      )}
      {mOpen && (
        <CreateMessage
          setMOpen={setMOpen}
          title={t('mesToDo.shareTaskList')}
          settingId={8}
          liste={operations.results.filter((v) => v.id === selectedRows[0])[0]}
        />
      )}
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  setMOpen(true)
                } else {
                  alert(t('mesToDo.selectOneToShareAlert'))
                }
              }}
            >
              {t('mesToDo.share')}
            </CustomButton>
            <CustomButton onClick={handelUpdte}>{t('mesToDo.edit')}</CustomButton>
            <CustomButton
              onClick={() => {
                CreateListeModal()
              }}
            >
              {t('mesToDo.add')}
            </CustomButton>
            <CustomButton onClick={deleteBulkOperations}>{t('mesToDo.delete')}</CustomButton>
          </Box>
        </Box>
        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
          setListeTaskId={setListeTaskId}
          setListeTaskName={setListeTaskName}
        />
      </Container>
    </>
  )
}
